/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Product;
(function (Product) {
    var productType;
    (function (productType) {
        productType["PRODUCT_TYPE_PRINT"] = "PRODUCT_TYPE_PRINT";
        productType["PRODUCT_TYPE_PRIORITY"] = "PRODUCT_TYPE_PRIORITY";
        productType["PRODUCT_TYPE_AUTOEXTEND"] = "PRODUCT_TYPE_AUTOEXTEND";
        productType["PRODUCT_TYPE_SHIELD"] = "PRODUCT_TYPE_SHIELD";
        productType["PRODUCT_TYPE_DIYRETURN"] = "PRODUCT_TYPE_DIYRETURN";
        productType["PRODUCT_TYPE_FILESMART"] = "PRODUCT_TYPE_FILESMART";
        productType["PRODUCT_TYPE_DFY_RETURN"] = "PRODUCT_TYPE_DFY_RETURN";
        productType["PRODUCT_TYPE_SUPPORT"] = "PRODUCT_TYPE_SUPPORT";
        productType["PRODUCT_TYPE_REPORT"] = "PRODUCT_TYPE_REPORT";
        productType["PRODUCT_TYPE_COURSE"] = "PRODUCT_TYPE_COURSE";
        productType["PRODUCT_TYPE_PERSONAL_EXTENSION"] = "PRODUCT_TYPE_PERSONAL_EXTENSION";
        productType["PRODUCT_TYPE_BUSINESS_EXTENSION"] = "PRODUCT_TYPE_BUSINESS_EXTENSION";
        productType["PRODUCT_TYPE_COUPON"] = "PRODUCT_TYPE_COUPON";
        productType["PRODUCT_TYPE_RESOURCE"] = "PRODUCT_TYPE_RESOURCE";
    })(productType = Product.productType || (Product.productType = {}));
    var status;
    (function (status) {
        status["PRODUCT_STATUS_ACTIVE"] = "PRODUCT_STATUS_ACTIVE";
        status["PRODUCT_STATUS_DRAFT"] = "PRODUCT_STATUS_DRAFT";
        status["PRODUCT_STATUS_DISCONTINUED"] = "PRODUCT_STATUS_DISCONTINUED";
        status["PRODUCT_STATUS_DEPRECATED"] = "PRODUCT_STATUS_DEPRECATED";
        status["PRODUCT_STATUS_UNPUBLISHED"] = "PRODUCT_STATUS_UNPUBLISHED";
    })(status = Product.status || (Product.status = {}));
})(Product || (Product = {}));
//# sourceMappingURL=Product.js.map